import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import getDateWithAnneeSemaineAndJourDepart
  from '@/services/general/getDateWithAnneeSemaineAndJourDepart';

export default function getDateDebutFinEchances(
  lignesCommandes, datePremierAffichage, dateCommande,
) {
  let dateDebutFin = null;
  lignesCommandes.forEach((ligne) => {
    if (ligne.ligneReseau && ligne.ligneReseau.anneeSemaine) {
      const dateAnneeSemaine = getDateWithAnneeSemaineAndJourDepart(
        ligne.ligneReseau.anneeSemaine,
        ligne.ligneReseau.jourDepart,
      );
      if (dateAnneeSemaine && moment(dateAnneeSemaine).isBefore(moment(dateDebutFin))
        || !dateDebutFin) {
        dateDebutFin = dateAnneeSemaine;
      }
    } else if (ligne.dateDebut
      && (moment(ligne.dateDebut).isBefore(moment(dateDebutFin)) || !dateDebutFin)) {
      dateDebutFin = ligne.dateDebut;
    }
  });
  if (!dateDebutFin) {
    dateDebutFin = dateCommande;
    if (datePremierAffichage) dateDebutFin = datePremierAffichage;
  }
  return new Date(cloneDeep(dateDebutFin));
}
